import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { string, bool } from "prop-types";
import { InputAdornment, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import brandTheme from "brandTheme/Theme";
import { textFormat } from "utils/Utils";

const style = () => ({
  textField: {
    display: "block",
    width: "100%",
    borderColor: brandTheme.black,
    '& .Mui-disabled':{
      color:brandTheme.fieldColor,
      backgroundColor:brandTheme.disabled,
    },
    "& .MuiInputBase-input": {
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: "0 12px",
    }
    },
    '& .MuiFormLabel-root.Mui-error':{
      color: brandTheme.errorColor,
    },
    "& .MuiInputLabel-outlined": {
      color:brandTheme.black,
      fontSize:'14px',
      "@media (max-width:768px)":{
          fontSize:'13px',
        },
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color:brandTheme.black,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
      '& :hover':{
        borderColor: brandTheme.black,
      }
    },
    '& .MuiOutlinedInput-notchedOutline':{
      borderColor: brandTheme.black,
    },
  },
});

const CustomeTextField = ({
  label,
  id,
  disabled,
  required,
  error,
  classes,
  onchange,
  search,
  setState,
  value,
  type,
  maxLength,
  setBlur,
  blurLabel,
  setError,
  index,
  name,
  groupindex,
  textLabel,
  searchTop
}) => {
  const codeFormat= type==="code" ? value?.replace(/[^a-zA-Z,0-9]/ig,'') : value;
  return (
    <div className={classes.textField}>
      {(search || searchTop)? (

        <TextField
          error={error }
          required={required}
          id={id}
          label={label}
          variant="outlined"
          style={{
            width: "100%",
            marginTop: searchTop ? '0' : "3%",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
            style: { width: "100%"},
          }}
          onChange={onchange}
          size="small"
        />

      ) : (
       
        <TextField
          error={error}
          required={required}
          id={id}
          label={label}
          variant="outlined"
          value={codeFormat}
          disabled={disabled ? true : false} 
          style={{
            width: "100%",
          }}
          type={type}
          onChange={(event) => {
          if(type === 'notCapital'){
            setState(event.target.value);
          }
          else if(type === "newSchemeCharge"){
            setState(event.target.value, index, label)
          }
          else if(type === "percentageNumber"){
            let value = event.target.value;
            const numericValue = value.match(/^\d*\.?\d{0,2}$/) ? value : '';
            setState(numericValue, index, label);
          }
          else if (type === "gst") {
            const formatted = event.target.value
              .replace(/[^a-zA-Z0-9]/g, "")
              .toUpperCase();
            setState(formatted);
          }
          else if(type === "insurance"){
            setState(event.target.value, index, textLabel)
          }
          else if(type === "chargeDays"){
            setState(event.target.value, groupindex, type , index)
          }
          else if(type === "chargeValue"){
            setState(event.target.value, groupindex, type , index)
          }
          else if(type === "chargeMinAmount"){
            setState(event.target.value, groupindex, type , index)
          }
          else if(type === "chargeMaxAmount"){
            setState(event.target.value, groupindex, type , index)
          }

          else if (name && name !== ""){
            setState(event.target.value, index, name)
          }
          else if (type === "noCapital"){
            setState(event.target.value)
          }
          else if(type === "prefix"){
            const onlyAlphabets = event.target.value.replace(/[^A-Za-z]/g, "");
            setState(onlyAlphabets.toUpperCase().slice(0, maxLength || 4));
          }
          else if (type === "packetNumber") {
            const formatted = event.target.value
              .replace(/[^A-Za-z0-9]/g, "")
              .toUpperCase();
            setState(formatted);
          }
          else{
              setState(textFormat(event.target.value))
            }
          }
           
          }
          onBlur={(event) => {
            if (name && name !== "" && setBlur){
              setBlur(event.target.value, index, blurLabel)
            } else{
            setBlur && setBlur(event.target.value, blurLabel);
            }
            setError &&  setError(false)
          }
          }
          inputProps={{ maxLength: maxLength }}
          size="small"
        />
        
      )}
   
   </div>
  );
};

CustomeTextField.propTypes = {
  label: string.isRequired,
  id: string,
  required: bool,
};
CustomeTextField.defaultProps = {
  label: string.isRequired,
  id: "text-field",
  required: false,
};
export default withStyles(style)(CustomeTextField);